import { STEPS } from "../../utils/constants";
import HowItWorksTemplate from "./HowItWorksTemplate";

export default function HowItWorks() {
  return <HowItWorksTemplate steps={STEPS} />;
}
